import React from "react";
import { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import api from "../../config/URL";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import CustomDatePicker from "../CustomDatePicker";

function DocumentEdit({ id, onSuccess, handleMenuClose }) {
  const [show, setShow] = useState(false);
  const [loadIndicator, setLoadIndicator] = useState(false);
  const [isModified, setIsModified] = useState(false);
  const userName = localStorage.getItem("userName");

  const handleClose = () => {
    setShow(false);
    handleMenuClose();
  };
  const handleShow = () => setShow(true);

  const validationSchema = Yup.object({
    folderName: Yup.string().required("*Folder Name is required"),
  });

  const formik = useFormik({
    initialValues: {
      folderName: "",
      expiredDate: null,
      updatedBy: userName,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoadIndicator(true);
      values.updatedBy = userName;
      const payload = {
        ...values,
        expiredDate: values.expiredDate
          ? values.expiredDate.toISOString().split("T")[0]
          : null,
        updatedBy: userName,
      };
      try {
        const response = await api.put(
          `/updateDocumentFoldersWithAws/${id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.status === 200) {
          onSuccess();
          handleClose();
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error(error);
      } finally {
        setLoadIndicator(false);
      }
    },
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    validate: (values) => {
      if (
        Object.values(values).some(
          (value) => typeof value === "string" && value.trim() !== ""
        )
      ) {
        setIsModified(true);
      } else {
        setIsModified(false);
      }
    },
  });

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await api.get(`/getAllDocumentFolderById/${id}`);
        // formik.setValues(response.data);
        formik.setValues({
          ...response.data,
          expiredDate: response.data.expiredDate
            ? new Date(response.data.expiredDate)
            : null,
        });
      } catch (error) {
        console.error("Error fetching data ", error);
      }
    };

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <p
        className="text-start mb-0 menuitem-style"
        onClick={handleShow}
        style={{
          whiteSpace: "nowrap",
          width: "100%",
        }}
      >
        Edit
      </p>
      <Dialog
        open={show}
        onClose={handleClose}
        maxWidth="xs"
        PaperProps={{
          style: { width: "420px" }, // ✅ compact modal
        }}
        disableBackdropClick={isModified}
        disableEscapeKeyDown={isModified}
      >
        <DialogTitle className="headColor">Edit Document</DialogTitle>
        <form
          onSubmit={formik.handleSubmit}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !formik.isSubmitting) {
              e.preventDefault();
            }
          }}
        >
          <DialogContent>
            <div className="container">
              <div className="row">
                
                <div className="col-12 mb-4 d-flex flex-column justify-content-end">
                  <label>
                    Expired Date<span className="text-danger">*</span>
                  </label>
                  <CustomDatePicker
                    name="expiredDate"
                    value={formik.values.expiredDate}
                    onChange={(date) => {
                      formik.setFieldValue("expiredDate", date);
                    }}
                    onBlur={() => {
                      formik.setFieldTouched("expiredDate", true);
                    }}
                  />

                  {formik.touched.expiredDate && formik.errors.expiredDate && (
                    <div className="invalid-feedback">
                      {formik.errors.expiredDate}
                    </div>
                  )}
                </div>
                <div className="col-12 mb-4 d-flex flex-column justify-content-end">
                  <label>
                    Folder Name<span className="text-danger">*</span>
                  </label>
                  <input
                    name="folderName"
                    type="text"
                    onKeyDown={(e) => e.stopPropagation()}
                    className={`form-control  ${
                      formik.touched.folderName && formik.errors.folderName
                        ? "is-invalid"
                        : ""
                    }`}
                    {...formik.getFieldProps("folderName")}
                  />
                  {formik.touched.folderName && formik.errors.folderName && (
                    <div className="invalid-feedback">
                      {formik.errors.folderName}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <button
              type="button"
              className="btn btn-sm btn-border bg-light text-dark"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              onSubmit={formik.handleSubmit}
              className="btn btn-button btn-sm"
              disabled={loadIndicator}
            >
              {loadIndicator && (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  aria-hidden="true"
                ></span>
              )}
              Update
            </button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default DocumentEdit;
